import React from "react";
import TermsArticle from "../../components/terms/terms-article";

const Terms = () => {


    return (
        <div className="min-h-screen bg-white text-gray-900">
            <div className="mx-auto max-w-4xl px-6 py-12">
                <h1 className="mb-8 text-3xl font-semibold">
                    Termini e Condizioni di Minigoal
                </h1>
                <TermsArticle />
            </div>
        </div>
    )


};

export default Terms;
